<script setup lang="ts">
import { Button } from '@toruslabs/vue-components/Button';
import { useClaimStore } from '../../store/claimStore';
import { computed } from 'vue';

const claimStore = useClaimStore();

const gameId = computed(() => claimStore.userInPartner.partnerUserName);
const partnerIcon = computed(() => claimStore.partner.logoUrl || '');
const partnerName = computed(() => claimStore.partner.name || '');

</script>

<template>
    <div class="flex flex-col justify-center items-center gap-4 min-h-[400px]">
        <div class="flex flex-col justify-center items-center gap-2">
            <img :src="partnerIcon" class="w-24 h-24">
            <p class="text-white text-base font-semibold text-center">{{ partnerName }}</p>
        </div>
        <p class="text-white text-xl font-bold text-center">Link Game ID to Start Earning Realm Points</p>
        <p class="text-white mb-4">{{ gameId }}</p>
        <div class="flex flex-col justify-center items-center gap-3">
            <Button
                class="!bg-moca-yellow !text-black !text-lg !font-bold !border !border-black !h-14 !rounded-full !px-6 !min-w-[200px]"
                @on-click="claimStore.addPartnerDetails">
                Link
            </Button>
            <button class="text-moca-gray-3 text-base font-bold underline" @click="claimStore.skipAddPartnerDetails">
                Skip for Now
            </button>
        </div>
    </div>
</template>
